export default {"src":"/_next/static/media/shopping_center_overview_2.96742e8e.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};